import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React from "react";
import SocialIcon from "./social-icon";

function TwitterIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props}>
      <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.5 8.778c-.441.196-.916.328-1.414.388.509-.305.898-.787 1.083-1.362-.476.282-1.003.487-1.564.597-.448-.479-1.089-.778-1.796-.778-1.59 0-2.758 1.483-2.399 3.023-2.045-.103-3.86-1.083-5.074-2.572-.645 1.106-.334 2.554.762 3.287-.403-.013-.782-.124-1.114-.308-.027 1.14.791 2.207 1.975 2.445-.346.094-.726.116-1.112.042.313.978 1.224 1.689 2.3 1.709-1.037.812-2.34 1.175-3.647 1.021 1.09.699 2.383 1.106 3.773 1.106 4.572 0 7.154-3.861 6.998-7.324.482-.346.899-.78 1.229-1.274z" />
    </SvgIcon>
  );
}

export default function TwitterSocialIcon(): JSX.Element {
  return (
    <SocialIcon
      ariaLabel="Twitter"
      href="https://twitter.com/morrisoncole"
      icon={
        <TwitterIcon
          sx={(theme) => ({
            fontSize: "3.5rem",
            [theme.breakpoints.down("md")]: {
              fontSize: "2.5rem",
            },
            color: "hsl(202, 89%, 53%)",
          })}
        />
      }
    />
  );
}
